export enum ENotificationFrequency {
    Instantane = 1,
    Journalier = 2,
    Favori = 3
}